import NonLoginShoppingCartButton from '~/components/NonLogin/NonLoginShoppingCartButton';
import { useCurrentUser } from '~/domains/auth/queries';
import ShoppingCartButton from '~/domains/cart/ShoppingCartButton';
import DeliveryFlag from '~/domains/delivery/DeliveryFlag';
import ProductPrice from '~/domains/products/components/ProductPrice';
import ProductImage from '~/domains/products/ProductImage';
import { useTrackProductEventProps } from '~/hooks/event';
import type { OAISchema } from '~/types/openapi';

type Props = {
  item: OAISchema['MarketSelectProductResponseV2'];
  className?: string;
  onItemClick: () => void;
};

const PlusmembershipCard = ({ item, className, onItemClick }: Props) => {
  const { isLoggedIn } = useCurrentUser();
  const [props, { trackAddCart }] = useTrackProductEventProps(item);

  return (
    <div
      className={className}
      role="presentation"
      onClick={() => {
        onItemClick();
      }}
    >
      <div {...props}>
        <ProductImage
          width={100}
          height={100}
          sizes="45vw"
          layout="responsive"
          src={item.mainImages![0]}
          alt={item.productName}
          isOutOfStock={item.isOutOfStock}
          status={item.status}
          rightBottom={
            !isLoggedIn ? (
              <NonLoginShoppingCartButton />
            ) : (
              <>
                {item.showCashnotePlusSuggestion ? undefined : (
                  <ShoppingCartButton
                    onClick={trackAddCart}
                    item={item}
                    className="mb-8 mr-8"
                  />
                )}
              </>
            )
          }
        />
        <div className="mb-4 text-hint typo-footnote200-regular">
          {item.mallName}
        </div>
        <div className="mb-4 line-clamp-2 whitespace-pre-line text-normal typo-paragraph100-regular">
          {item.productName}
        </div>
        <ProductPrice {...item} reverse />
        <DeliveryFlag
          flags={item.deliveryFlags}
          isFreeShipping={item.isFreeShipping}
        />
      </div>
    </div>
  );
};

export default PlusmembershipCard;
